import prependHttp from 'prepend-http';

import quickConnectTypes from 'lib/common/constants/quickConnectTypes';

import getTransferEndpoint from 'lib/common/api/getTransferEndpoint';
import connectAction from 'lib/common/utils/connectAction';

import { IReference, Tab } from '../useCreateAgentTask';

export default async function createTask({
  fetch_,
  config,
  selectedTab,
  selectedEntity,
  references,
  agent,
  name,
  description,
  scheduledDateTime,
}: {
  fetch_: (url: string, options?: RequestInit) => Promise<Response>;
  config: Record<string, any>;
  selectedTab: Tab;
  selectedEntity: { value: string };
  references: IReference[];
  agent: connect.Agent | null;
  name: string;
  description: string;
  scheduledDateTime: Date | null;
}) {
  const endpoint = await getTransferEndpoint({
    fetch_,
    config,
    type: selectedTab === Tab.QUEUE ? quickConnectTypes.QUEUE : quickConnectTypes.AGENT,
    identifier: selectedEntity.value,
    asEndpointObject: true,
  });

  if (!endpoint) {
    return Promise.reject();
  }

  const optionalURLPayload = references.length
    ? {
        references: references.reduce(
          (allReferences, reference) => ({
            ...allReferences,
            [reference.name]: {
              type: reference.type,
              value: reference.type === 'URL' ? prependHttp(reference.value, { https: true }) : reference.value,
            },
          }),
          {}
        ),
      }
    : {};

  return connectAction('createTask', agent, {
    name,
    description,
    endpoint,
    scheduledTime: scheduledDateTime ? scheduledDateTime?.getTime() / 1000 : undefined,
    ...optionalURLPayload,
  });
}
